<hlm-toaster richColors position="bottom-center" />
<router-outlet></router-outlet>
